export default __webpack_public_path__ + "static/nevroherb-04c130bfd9a59e7a2ec58da52419361a.jpg";